import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { peformanceNewGoalRequest, peformanceNewReviewRequestStatus } from '../../../redux/performance/peformance.action'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import moment from "moment";

const PerformanceAddGoal = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { newPeformanceGoalSuccess, newPeformanceGoalError, newPeformanceGoalReqStatus } = useSelector(state => state.peformance)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [reviewYear, setReviewYear] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [endDate, setEndDate] = useState(new Date())

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_ADD_GOAL, true)
            fetchBusinessList()
        }
        setReviewYear(new Date().getFullYear())
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (newPeformanceGoalReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (newPeformanceGoalReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newPeformanceGoalError.message)
        }
        if (newPeformanceGoalReqStatus?.length) {
            dispatch(peformanceNewReviewRequestStatus(''))
        }
    }, [newPeformanceGoalSuccess, newPeformanceGoalError, newPeformanceGoalReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PERFORMANCE_ADD_GOAL) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PERFORMANCE_ADD_GOAL, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    const handleAddNewGoalClick = () => {
        setTitle('')
        setDescription('')
        setEndDate(new Date())
        setShowSuccessModal(false)
    }

    const handleSubmitClick = () => {
        if (isEmpty(title)) {
            displayErrorToast('Goal title cannot be blank')
        } else if (isEmpty(description)) {
            displayErrorToast('Description cannot be blank')
        } else if (isEmpty(endDate)) {
            displayErrorToast('End date not selected')
        } else {
            setLoading(true)
            const data = {
                reviewYear: reviewYear,
                employeeId: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                employeeUserType: user.data.userDetails.userType,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.businessId : employeeSelectedLocation,
                title: title,
                description: description,
                endDate: moment(endDate).utc().format("YYYY-MM-DD hh:mm:ss A")

            }
            dispatch(peformanceNewGoalRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Goal' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new goal' />
                    <CommonInputFloatFull
                        type='number'
                        id='reviewYear'
                        placeholder='Review Year'
                        onChange={e => setReviewYear(e.target.value)}
                        value={reviewYear}
                        isDisable={false}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='title'
                        onChange={e => setTitle(e.target.value)}
                        placeholder='Title'
                        value={title}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Description'
                        value={description}
                        multiline={true}
                        rows={4}
                    />
                    <div className="as-date-parent-container-full">
                        <FormFieldLabel label='End Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={endDate}
                            minDate={new Date()}
                            onChange={(date) => {
                                setEndDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel className='up-bold-label' label='Business Information' />
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="content-error">{userBusinessListError.message}</div>}
                        <FormFieldLabel label='Select Business Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="content-error">{businessLocationListError.message}</div>}
                    </div>}
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{newPeformanceGoalSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another goal?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleAddNewGoalClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PerformanceAddGoal